export { default } from './TimelineItem';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TimelineItem/index.js
// module id = 898
// module chunks = 2